import Corporates from "@/views/market/Corporates.vue";
import Partnerships from "@/views/market/Partnerships.vue";
import Sectors from "@/views/market/Sectors.vue";
import SubSectors from "@/views/market/SubSectors.vue";

export default [
    {
        path: '/market/sectors',
        component: Sectors,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/market/sub-sectors',
        component: SubSectors,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/market/corporates',
        component: Corporates,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/market/partnerships',
        component: Partnerships,
        meta: {
            access: ['admin'],
        }
    },
]
